import React, { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import FullPageSpinner from '@/components/FullPageSpinner';
import { unauthenticatedRoutes } from '@/routes/unAuthenticatedRoutes/unAuthenticRoutesConfig';


const UnauthenticatedApp = () => {
  return (
    <BrowserRouter>
      <Routes>
          {unauthenticatedRoutes.map(({ path, component: Component, lazyComponent, props }, index) => {
              if (Component) {
                  return (
                      <Route
                          key={index}
                          path={path}
                          element={<Component {...(props || {})} />}
                      />
                  );
              }
              else if (lazyComponent) {
                  const LazyComp = React.lazy(lazyComponent);
                  return (
                      <Route
                          key={index}
                          path={path}
                          element={
                              <Suspense fallback={<FullPageSpinner />}>
                                  <LazyComp />
                              </Suspense>
                          }
                      />
                  );
              }
              return null;
          })}

        <Route path="/*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default UnauthenticatedApp;
